import * as React from 'react';
import { Body1, Image, Label, UIHeading2 } from '@cian/ui-kit';

import grayStars from '../../../../../AiSummaryModalDesktop/assets/grayStars.svg';
import type { IAiSummaryEmptyState } from '../../../../../AiSummaryModalDesktop/types';
import * as styles from './styles.css';
import clsx from 'clsx';

export interface INoDataBlockProps extends IAiSummaryEmptyState {
  isFullContent: boolean;
}

export const NoDataBlock = ({ title, subtitle, tags, isFullContent }: INoDataBlockProps): React.JSX.Element => {
  return (
    <div className={clsx(styles['container'], isFullContent && styles['full-container'])}>
      <div className={styles['icon-wrapper']}>
        <Image height={24} src={grayStars} width={24} />
      </div>
      <div className={styles['text-wrapper']}>
        <div className={styles['heading-text-wrapper']}>
          <UIHeading2 textAlign="center">{title}</UIHeading2>
        </div>
        <Body1 textAlign="center">{subtitle}</Body1>
      </div>
      <div className={styles['labels-wrapper']}>
        <div className={styles['badge-container']}>
          {tags.map(tag => (
            <Label background="accent-main-secondary" color="accent-main-primary" key={tag.text}>
              {tag.text}
            </Label>
          ))}
        </div>
      </div>
    </div>
  );
};
